import {
  Alert,
  Button,
  Stack,
  SxProps,
  Theme,
  Typography,
} from '@mui/material';
import { FormattedMessage } from 'react-intl';

import { useTranslatedText } from 'hooks/useTranslatedText';

import { useCartOutOfStockItems } from 'components/@tickets/hooks';

interface Props {
  sx?: SxProps<Theme>;
}

const CartOutOfStockAlert = ({ sx }: Props) => {
  const {
    hasOutOfStockCartItems,
    outOfStockCartItems,
    onRemoveOutOfStockCartItems,
  } = useCartOutOfStockItems();
  const localize = useTranslatedText();

  if (!hasOutOfStockCartItems) return null;

  return (
    <Alert severity="error" sx={[...(Array.isArray(sx) ? sx : [sx])]}>
      <Stack>
        <Typography
          variant="h7"
          sx={{
            mb: 1,
          }}
        >
          <FormattedMessage id="tickets.cart.out_of_stock.alert.title" />
        </Typography>
        <Typography
          variant="small"
          sx={{
            fontWeight: 'bold',
            mb: 0.5,
          }}
        >
          <FormattedMessage id="tickets.cart.out_of_stock.alert.description" />
        </Typography>
        {outOfStockCartItems.map(
          ({ id, name }) =>
            name && (
              <Typography
                key={id}
                variant="small"
                sx={{
                  fontStyle: 'italic',
                }}
              >
                {localize(name)} (
                <FormattedMessage id="tickets.cart.out_of_stock.alert.list" />)
              </Typography>
            ),
        )}

        <Button
          sx={{ width: 'fit-content', mt: 2 }}
          variant="contained"
          color="primary"
          onClick={onRemoveOutOfStockCartItems}
        >
          <FormattedMessage id="tickets.cart.out_of_stock.alert.cta" />
        </Button>
      </Stack>
    </Alert>
  );
};

export default CartOutOfStockAlert;
